<template>
  <footer class="text-white container mx-auto mt-16 overflow-hidden">
    <div class="flex justify-center my-6">
      <a
        v-for="(social, s) in socials"
        :key="s"
        type="button"
        class="mx-2"
        :href="social.href"
        target="_blank"
        data-aos="zoom-in-up"
        :data-aos-delay="s * 100"
      >
        <img
          :src="social.src"
          :alt="`social-${s},nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art`"
          class="h-16"
        />
      </a>
    </div>
    <div class="flex justify-center my-6 capitalize">
      &copy; 2022 - {{ new Date().getFullYear() }} Argon - all rights reserved
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerComponent",
  props: {
    links: { type: Array, default: () => [] },
    socials: { type: Array, default: () => [] },
  },
}
</script>
